const {
  zipCodeRegexNumeric,
  onlyNumericNormalize,
  COMMA
} = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 4);

const states = {
  ACT: 'Australian Capital Territory',
  NSW: 'New South Wales',
  NT: 'Northern Territory',
  QLD: 'Queensland',
  SA: 'South Australia',
  TAS: 'Tasmania',
  VIC: 'Victoria',
  WA: 'Western Australia'
};

const stateOptions = [];
const stateArray = Object.keys(states);
stateArray.forEach((stateCode) => {
  stateOptions.push({ value: stateCode, name: states[stateCode] });
});

exports.countryDefinition = {
  country: 'Australia',
  code: 'AU',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Address' },
    address2: { label: 'Address 2' },
    city: { label: 'City', width: 0.5 },
    stateCode: {
      type: 'array',
      array: stateOptions,
      label: 'State',
      width: 0.5
    },
    zipCode: {
      label: 'PostCode',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  states,
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city', COMMA, 'stateCode', COMMA, 'zipCode']
  ],
  formFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city', 'stateCode'],
    ['zipCode']
  ],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    { field: 'stateCode' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(4)),
      error: 'Must be 4 characters, 1234'
    }
  ]
};
